module.exports = __webpack_public_path__ + "static/img/img1d.efea091.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/img1d.png
// module id = 1C4S
// module chunks = 1